import React, { useState } from 'react';
import { MailIcon, ArrowLeftIcon, MapIcon, CalendarIcon, PresentationIcon, ChevronRightIcon, ShieldCheckIcon, FileTextIcon, ClipboardListIcon, ArrowRightIcon, PlayCircleIcon, XIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function InvestorDeckPage() {
  const [videoOpen, setVideoOpen] = useState(false);
  return <div className="min-h-screen bg-gray-50 font-sans text-[#111111]" data-id="element-1635">
      {/* Private Header */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-50" data-id="element-1636">
        <div className="max-w-7xl mx-auto px-4 md:px-6 h-14 md:h-16 flex items-center justify-between" data-id="element-1637">
          <div className="flex items-center space-x-2 md:space-x-4 min-w-0" data-id="element-1638">
            <Link to="/" className="text-gray-500 hover:text-[#631bb7] transition-colors shrink-0" data-id="element-1639">
              <ArrowLeftIcon size={18} data-id="element-1640" />
            </Link>
            <div className="h-5 w-px bg-gray-200 shrink-0" data-id="element-1641"></div>
            <img src="https://cdn.magicpatterns.com/uploads/u2RsmpFkExbV8oAVAJrtqh/Caveo-Lockup-FC.png" alt="Caveo" className="h-5 md:h-6 shrink-0" data-id="element-1642" />
            <span className="bg-gray-100 text-gray-600 text-[10px] md:text-xs font-semibold px-1.5 md:px-2 py-0.5 md:py-1 rounded-full uppercase tracking-wide shrink-0 hidden sm:inline-block" data-id="element-1643">
              Investor Portal
            </span>
          </div>
          <div className="text-xs md:text-sm text-gray-500 shrink-0" data-id="element-1644">
            Confidential
          </div>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-4 md:px-6 py-6 md:py-8 space-y-6 md:space-y-8" data-id="element-1645">
        {/* Welcome / Hero */}
        <section className="text-center max-w-3xl mx-auto" data-id="element-1646">
          <h1 className="text-2xl md:text-4xl font-bold mb-2 md:mb-3 text-[#111111]" data-id="element-1647">
            Welcome to the Caveo Investor Portal
          </h1>
          <p className="text-base md:text-lg text-gray-600 leading-relaxed" data-id="element-1648">
            Access our strategic overview and product roadmap as we redefine
            family digital safety.
          </p>
        </section>

        {/* Review — 3 visual cards */}
        <section className="max-w-4xl mx-auto" data-id="element-1649">
          <p className="text-[10px] md:text-xs font-medium text-gray-400 uppercase tracking-wider mb-2 md:mb-3" data-id="element-1650">
            Review
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4" data-id="element-1651">
            {/* Product Overview Card */}
            <Link to="/investor-overview" className="group bg-white rounded-xl border border-gray-200 shadow-sm hover:shadow-lg hover:border-[#631bb7] transition-all no-underline overflow-hidden flex flex-col" data-id="element-1652">
              <div className="p-4 pb-3" data-id="element-1653">
                <p className="font-semibold text-[#631bb7] uppercase tracking-wider mb-1.5 text-[14px]" data-id="element-1654">
                  Product Overview
                </p>
                <h2 className="text-sm md:text-base font-bold text-[#111111] leading-snug mb-3" data-id="element-1655">
                  Review our approach & offering
                </h2>
                <span className="inline-block bg-[#631bb7] text-white px-4 py-2 rounded-lg font-semibold text-sm group-hover:bg-[#521099] transition-colors text-center" data-id="element-1656">
                  View Overview
                </span>
              </div>
              <div className="mt-auto px-3 pb-3" data-id="element-1657">
                <div className="rounded-lg overflow-hidden border border-gray-100 bg-gray-50 max-h-[120px]" data-id="element-1658">
                  <img src="https://cdn.magicpatterns.com/uploads/93CQkpzDHgFWnEcf4Lj9VY/Solution_Tile.png" alt="Product Overview preview" className="w-full h-full object-cover object-top group-hover:scale-[1.02] transition-transform duration-300" data-id="element-1659" />
                </div>
              </div>
            </Link>

            {/* Current Roadmap Card */}
            <Link to="/investor-roadmap" className="group bg-white rounded-xl border border-gray-200 shadow-sm hover:shadow-lg hover:border-[#631bb7] transition-all no-underline overflow-hidden flex flex-col" data-id="element-1660">
              <div className="p-4 pb-3" data-id="element-1661">
                <p className="font-semibold text-[#631bb7] uppercase tracking-wider mb-1.5 text-[14px]" data-id="element-1662">
                  Current Roadmap
                </p>
                <h2 className="text-sm md:text-base font-bold text-[#111111] leading-snug mb-3" data-id="element-1663">
                  Review our product roadmap
                </h2>
                <span className="inline-block bg-[#631bb7] text-white px-4 py-2 rounded-lg font-semibold text-sm group-hover:bg-[#521099] transition-colors text-center" data-id="element-1664">
                  View Roadmap
                </span>
              </div>
              <div className="mt-auto px-3 pb-3" data-id="element-1665">
                <div className="rounded-lg overflow-hidden border border-gray-100 bg-gray-50 max-h-[120px]" data-id="element-1666">
                  <img src="https://cdn.magicpatterns.com/uploads/h36X9PXxxPnRR1zyfhF4pm/Roadmap.png" alt="Current Roadmap preview" className="w-full h-full object-cover object-top group-hover:scale-[1.02] transition-transform duration-300" data-id="element-1667" />
                </div>
              </div>
            </Link>

            {/* Video Overview Card */}
            <button onClick={() => setVideoOpen(true)} className="group bg-white rounded-xl border border-gray-200 shadow-sm hover:shadow-lg hover:border-[#631bb7] transition-all overflow-hidden flex flex-col text-left cursor-pointer w-full" data-id="element-1668">
              <div className="p-4 pb-3" data-id="element-1669">
                <p className="font-semibold text-[#631bb7] uppercase tracking-wider mb-1.5 text-[14px]" data-id="element-1670">
                  Video Overview
                </p>
                <h2 className="text-sm md:text-base font-bold text-[#111111] leading-snug mb-3" data-id="element-1671">
                  Watch a quick intro video
                </h2>
                <span className="inline-block bg-[#631bb7] text-white px-4 py-2 rounded-lg font-semibold text-sm group-hover:bg-[#521099] transition-colors text-center" data-id="element-1672">
                  Watch Video
                </span>
              </div>
              <div className="mt-auto px-3 pb-3" data-id="element-1673">
                <div className="rounded-lg overflow-hidden border border-gray-100 bg-gray-50 relative max-h-[120px]" data-id="element-1674">
                  <img src="https://cdn.magicpatterns.com/uploads/kQTLbSzGqPauqHqmHm18o4/Video_Tile.png" alt="Video Overview preview" className="w-full h-full object-cover object-top group-hover:scale-[1.02] transition-transform duration-300" data-id="element-1675" />
                  <div className="absolute inset-0 flex items-center justify-center" data-id="element-1676">
                    <div className="w-9 h-9 bg-white/90 rounded-full flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform" data-id="element-1677">
                      <PlayCircleIcon size={20} className="text-[#631bb7]" data-id="element-1678" />
                    </div>
                  </div>
                </div>
              </div>
            </button>
          </div>
        </section>

        {/* Next Steps */}
        <section className="max-w-4xl mx-auto" data-id="element-1679">
          <p className="text-[10px] md:text-xs font-medium text-gray-400 uppercase tracking-wider mb-2 md:mb-3" data-id="element-1680">
            Next Steps
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4" data-id="element-1681">
            {/* Email Us */}
            <a href="mailto:jbp@caveohq.com" className="group bg-white rounded-xl border border-gray-200 shadow-sm hover:shadow-lg hover:border-[#631bb7] transition-all p-5 md:p-6 flex flex-col items-center text-center no-underline" data-id="element-1682">
              <div className="w-10 h-10 bg-[#f0ebf8] rounded-full flex items-center justify-center mb-3 shrink-0" data-id="element-1683">
                <MailIcon size={20} className="text-[#631bb7]" data-id="element-1684" />
              </div>
              <h3 className="font-bold text-base text-[#111111] mb-2" data-id="element-1685">
                Email Us
              </h3>
              <p className="text-xs text-gray-500 mb-4 flex-1" data-id="element-1686">
                Send us a due diligence question or request additional
                materials.
              </p>
              <span className="bg-[#631bb7] text-white w-full text-center rounded-lg font-semibold text-sm py-2.5 group-hover:bg-[#521099] transition-colors block" data-id="element-1687">
                Send Email
              </span>
            </a>

            {/* Book a Meeting */}
            <a href="https://calendar.app.google/EnoqEH7z4cY89jjN8" target="_blank" rel="noopener noreferrer" className="group bg-white rounded-xl border border-gray-200 shadow-sm hover:shadow-lg hover:border-[#631bb7] transition-all p-5 md:p-6 flex flex-col items-center text-center no-underline" data-id="element-1688">
              <div className="w-10 h-10 bg-[#f0ebf8] rounded-full flex items-center justify-center mb-3 shrink-0" data-id="element-1689">
                <CalendarIcon size={20} className="text-[#631bb7]" data-id="element-1690" />
              </div>
              <h3 className="font-bold text-base text-[#111111] mb-2" data-id="element-1691">
                Book a Meeting
              </h3>
              <p className="text-xs text-gray-500 mb-4 flex-1" data-id="element-1692">
                Schedule a deep dive into our product roadmap and strategy.
              </p>
              <span className="bg-[#631bb7] text-white w-full text-center rounded-lg font-semibold text-sm py-2.5 group-hover:bg-[#521099] transition-colors block" data-id="element-1693">
                Schedule Now
              </span>
            </a>

            {/* Invest Now */}
            <Link to="/invest" className="group bg-white rounded-xl border border-gray-200 shadow-sm hover:shadow-lg hover:border-[#631bb7] transition-all p-5 md:p-6 flex flex-col items-center text-center no-underline" data-id="element-1694">
              <div className="w-10 h-10 bg-[#f0ebf8] rounded-full flex items-center justify-center mb-3 shrink-0" data-id="element-1695">
                <ArrowRightIcon size={20} className="text-[#631bb7]" data-id="element-1696" />
              </div>
              <h3 className="font-bold text-base text-[#111111] mb-2" data-id="element-1697">
                Invest Now
              </h3>
              <p className="text-xs text-gray-500 mb-4 flex-1" data-id="element-1698">
                Review disclosures, the SAFE agreement, and submit your
                interest.
              </p>
              <span className="bg-[#631bb7] text-white w-full text-center rounded-lg font-semibold text-sm py-2.5 group-hover:bg-[#521099] transition-colors block" data-id="element-1699">
                Get Started
              </span>
            </Link>
          </div>
        </section>

        {/* Pitch Deck */}
        <section className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden max-w-4xl mx-auto" data-id="element-1700">
          <div className="flex items-center gap-3 px-5 py-3 border-b border-gray-100 bg-gray-50" data-id="element-1701">
            <PresentationIcon size={18} className="text-[#631bb7]" data-id="element-1702" />
            <h2 className="text-base font-bold text-[#111111]" data-id="element-1703">Pitch Deck</h2>
          </div>
          <div className="w-full" style={{
          aspectRatio: '16/9'
        }} data-id="element-1704">
            <iframe src="https://docs.google.com/presentation/d/1fVC6uDiXaNJSw2id2Ss5M1aR9t8FIXEyFTrRizzsmzk/embed?start=false&loop=false&delayms=3000" className="w-full h-full border-0" allowFullScreen title="Caveo Pitch Deck" data-id="element-1705" />
          </div>
        </section>

        {/* Trust / Logo Strip */}
        <section className="max-w-4xl mx-auto" data-id="element-1706">
          <p className="text-center text-xs md:text-sm font-medium text-gray-400 uppercase tracking-wider mb-4 md:mb-6" data-id="element-1707">
            Built by leaders from
          </p>
          <div className="flex flex-wrap items-center justify-center gap-x-8 md:gap-x-12 gap-y-4 grayscale opacity-50" data-id="element-1708">
            <img src="https://cdn.magicpatterns.com/uploads/nmqUJqLxx2VskE1njSdPet/Experian_logo.svg.png" alt="Experian" className="h-6 md:h-8 max-w-[100px] md:max-w-[120px] object-contain" data-id="element-1709" />
            <img src="https://cdn.magicpatterns.com/uploads/fnXGBwy5K7uyX2UvFt6ups/Asana_logo.svg.png" alt="Asana" className="h-5 md:h-7 max-w-[80px] md:max-w-[100px] object-contain" data-id="element-1710" />
            <img src="https://cdn.magicpatterns.com/uploads/jTvJx4FmjnAA5ZM439Lq8G/drift-logo-png_seeklogo-394571.png" alt="Drift" className="h-5 md:h-7 max-w-[70px] md:max-w-[90px] object-contain" data-id="element-1711" />
            <img src="https://cdn.magicpatterns.com/uploads/vjVVFtuWSA5UFtZmC7CMpG/Intel-Logo.png" alt="Intel" className="h-6 md:h-8 max-w-[60px] md:max-w-[70px] object-contain" data-id="element-1712" />
            <img src="https://cdn.magicpatterns.com/uploads/gifY524awm2QkgRHAkporM/NBCUniversal_2026_Logo.svg" alt="NBCUniversal" className="h-5 md:h-7 max-w-[110px] md:max-w-[140px] object-contain" data-id="element-1713" />
          </div>
        </section>
      </main>

      <footer className="bg-white border-t border-gray-200 py-6 md:py-8 mt-auto" data-id="element-1714">
        <div className="max-w-7xl mx-auto px-4 md:px-6 text-center text-xs md:text-sm text-gray-500" data-id="element-1715">
          <p data-id="element-1716">&copy; 2026 AppEmbrace, Inc. DBA Caveo. All rights reserved.</p>
          <p className="mt-1 md:mt-2 text-xs text-gray-400" data-id="element-1717">
            This page contains confidential information intended only for
            authorized investors. Do not share or distribute without permission.
          </p>
        </div>
      </footer>

      {/* Video Modal */}
      {videoOpen && <div className="fixed inset-0 bg-black/70 z-[9999] flex items-center justify-center p-4" onClick={() => setVideoOpen(false)} data-id="element-1718">
          <div className="relative w-full max-w-4xl bg-black rounded-2xl overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-1719">
            <button onClick={() => setVideoOpen(false)} className="absolute top-3 right-3 z-10 w-9 h-9 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors border-0 cursor-pointer" data-id="element-1720">
              <XIcon size={18} className="text-white" data-id="element-1721" />
            </button>
            <div className="w-full relative" style={{
          paddingBottom: '56.25%',
          height: 0
        }} data-id="element-1722">
              <iframe src="https://jumpshare.com/embed/VeYl2TaJ" frameBorder="0" allowFullScreen className="absolute top-0 left-0 w-full h-full" title="Caveo Overview Video" data-id="element-1723" />
            </div>
          </div>
        </div>}
    </div>;
}